module.exports = __webpack_public_path__ + "img/waerme-img2av3.4b69b29b.png";